import { combineReducers } from "@reduxjs/toolkit";
import memberProfileReducer from "./profile/memberProfileSlice";

export default combineReducers({
    memberProfile: memberProfileReducer,
});
